import { ONBOARDING_STEPS, type StepStatus } from '@/stores/onboarding'

interface StepIndicatorProps {
  currentStep: number
  stepStatus: Record<number, StepStatus>
}

const MARKER_FOR_STATUS: Record<StepStatus, string> = {
  completed: '✓',
  skipped: '⤳',
  pending: '·',
}

export function StepIndicator({ currentStep, stepStatus }: StepIndicatorProps) {
  return (
    <ol className="flex flex-wrap items-center gap-x-3 gap-y-2 font-mono text-xs text-muted">
      {ONBOARDING_STEPS.map((step, idx) => {
        const status = stepStatus[step.num] ?? 'pending'
        const isActive = step.num === currentStep
        const marker = MARKER_FOR_STATUS[status]
        const labelClass = [
          'flex items-baseline gap-1.5 px-1',
          isActive ? 'text-ink' : '',
          status === 'completed' ? 'text-bernstein' : '',
          status === 'skipped' ? 'text-faint' : '',
        ]
          .filter(Boolean)
          .join(' ')

        return (
          <li key={step.num} className="flex items-baseline gap-3">
            <span className={labelClass} aria-current={isActive ? 'step' : undefined}>
              <span aria-hidden="true">{marker}</span>
              <span>
                {step.num}. {step.label}
              </span>
            </span>
            {idx < ONBOARDING_STEPS.length - 1 && (
              <span aria-hidden="true" className="text-faint">
                ·
              </span>
            )}
          </li>
        )
      })}
    </ol>
  )
}
